import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CBMError, Task } from 'app/models';
import { DownloadService, HttpService } from 'app/services';

export abstract class ExportTaskBase {
  public errorMessages: CBMError[];

  constructor(private readonly httpService: HttpService, protected readonly downloadService: DownloadService) {}

  protected handleTaskAsync(responseObservableWithTaskLocationHeader: Observable<Response>) {
    responseObservableWithTaskLocationHeader.subscribe(
      (res: Response) => {
        const location = res.headers.get('location');
        if (location) {
          this.waitForTask(location);
        } else {
          // TODO Can we set this.errorMessages to anything that would help the user in this case?
          console.log('Response does not include location header', res);
          this.onTaskCheckError();
        }
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
        this.onTaskCheckError();
      }
    );
  }

  protected waitForTask(taskUrl: string) {
    this.httpService.get<Task>(taskUrl).subscribe(
      task => {
        if (task.status === 'created' || task.status === 'running') {
          setTimeout(() => this.waitForTask(taskUrl), 5000);
        } else if (task.status === 'failed') {
          // Something went wrong, although it's not really a 500 status
          this.errorMessages = [new CBMError('D0001', task.status)];
          this.onTaskCheckError();
        } else if (task.status === 'done') {
          this.onTaskFinished(task);
        }
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
        this.onTaskCheckError();
      }
    );
  }

  protected abstract onTaskFinished(task: Task);

  protected abstract onTaskCheckError();
}



// WEBPACK FOOTER //
// ./src/app/shared/export/exportTaskBase.ts